import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzNoAnimationModule } from 'ng-zorro-antd/core/no-animation';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';

import { TranslateModule } from '@ngx-translate/core';

import { SharedDirectivesModule } from '@app/shared/shared-directives.module';
import { BillingDetailsComponent } from './components/details/billing-details.component';
import { BillingFormComponent } from './components/form/billing-form.component';
import { BillingVolumeSummaryComponent } from './components/summary/billing-volume-summary.component';
import { EqualSizeModule } from '@app/shared/modules/equal-size/equal-size.module';
import { BillingVolumeSummaryLegacyComponent } from '@app/settings/shared/modules/billing/components/legacy/billing-volume-summary-legacy.component';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,

    NzFormModule,
    NzIconModule,
    NzSpinModule,
    NzInputModule,
    NzButtonModule,
    NzSelectModule,
    NzToolTipModule,
    NzNoAnimationModule,
    NzAutocompleteModule,

    TranslateModule,

    SharedDirectivesModule,
    EqualSizeModule,
  ],
  declarations: [
    BillingDetailsComponent,
    BillingFormComponent,
    BillingVolumeSummaryComponent,
    BillingVolumeSummaryLegacyComponent,
  ],
  exports: [
    BillingDetailsComponent,
    BillingFormComponent,
    BillingVolumeSummaryComponent,
    BillingVolumeSummaryLegacyComponent,
  ],
})
export class BillingModule {}
